import {axios, HOST, config} from './settiing';

import lostItemApi from './lostItem';
import reservationApi from './reservation';
import canceledReservationApi from './canceledReservation';
import noticeApi from './notice';
import termsApi from './terms';
import groupApi from './group';
import approvementApi from './approvement';
import driverApi from './driver';
import vehicleApi from './vehicle';
import customerApi from './customer';
import driveScheduleApi from './driveSchedule';
import adminApi from './admin';
import driveLogApi from './driveLog';
import centerApi from './center';
import voucherApi from './voucher';
import refuelingApi from './refueling';
import maintenanceApi from './maintenance';
import documentApi from './document';
import mapApi from './map';
import odbDeviceApi from './odbDevice';
import receptApi from './recept';
import monitoringApi from './monitoring';
import configApi from './config';
import centerOperTimeApi from './centerOperTime';
import fareApi from './fare';
import roleApi from './role';
import drtApi from './drtApi';
import evStationApi from './evStation';
import chargeLogApi from './chargeLog';
import membershipCardApi from './membershipCard';
import deliveryApi from "@/api/delivery";
import couponApi from '@/api/coupon';

export default {
  ...lostItemApi,
  ...reservationApi,
  ...canceledReservationApi,
  ...noticeApi,
  ...termsApi,
  ...groupApi,
  ...approvementApi,
  ...driverApi,
  ...vehicleApi,
  ...customerApi,
  ...driveScheduleApi,
  ...adminApi,
  ...driveLogApi,
  ...centerApi,
  ...voucherApi,
  ...refuelingApi,
  ...maintenanceApi,
  ...documentApi,
  ...mapApi,
  ...odbDeviceApi,
  ...receptApi,
  ...monitoringApi,
  ...configApi,
  ...centerOperTimeApi,
  ...fareApi,
  ...roleApi,
  ...drtApi,
  ...evStationApi,
  ...chargeLogApi,
  ...membershipCardApi,
  ...deliveryApi,
  ...couponApi,

  /** login api */
  login(data) {
    return axios.post(`${HOST}/login/process`, data, config);
  },
  logout(){
    return axios.post(`${HOST}/logout`, config);
  },

  downloadFiles(fileName) {
    return axios.get(`${HOST}/docs/${fileName}`, {withCredentials: true, responseType: 'blob'});
  }
};
